import { toast } from 'react-toastify';
import i18n from 'i18next';

export const download = (blob, fileName, fileExtension = '') => {
  const objectUrl = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.style.display = 'none';
  a.href = objectUrl;
  a.download = fileExtension ? `${fileName}.${fileExtension}` : fileName;
  document.body.appendChild(a);
  a.click();
  URL.revokeObjectURL(objectUrl);
  document.body.removeChild(a);
};

export const preview = (blob, fileName) => {
  // window might be null if user has an ad blocker or had disable pop-up
  const newWindow = window.open();
  if (newWindow) {
    newWindow.location.assign(window.URL.createObjectURL(blob));
  } else {
    download(blob, fileName);
  }
};

export const downloadFile = async (downloadedFile, fileName, extension, callback) => {
  if (downloadedFile.type === 'text/plain') {
    toast.warning(await downloadedFile.text());
  } else {
    download(downloadedFile, fileName, extension);
    callback();
    toast.success(i18n.t('common.message.success.downloaded', { entity: 'mission' }));
  }
};

export const inputToFormData = (input, formDataName) => {
  const formData = new FormData();
  if (input.target && input.target.files) {
    const file = input.target.files[0];
    formData.set(formDataName, file);
    return formData;
  }
  return formData;
};
